import { H4, SH3, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import LottieView from 'lottie-react-native'

type VerifyOtpHeadingProps = {
  mobileNumber: string
  heading: string
}
const VerifyOtpHeading = ({ mobileNumber, heading }: VerifyOtpHeadingProps) => {
  return (
    <Stack className={`mt-4 items-center justify-center`}>
      <LottieView
        autoPlay
        className={'h-[85] w-[88] self-center'}
        source={require('../../assets/lottie/SMSVerification.json')}
      />
      <H4 className="mt-[28] text-center">{heading}</H4>
      <SH3 className=" text-grays-60 mt-1 text-center ">
        {i18n.t('otpInput.sent', { number: mobileNumber?.slice(2) })}
      </SH3>
    </Stack>
  )
}

export default VerifyOtpHeading
